import React, { useContext } from 'react'
import { ChangePresentContext, MedPlanContext } from '../../SingleEvent'
import { Grid, TextField } from '@mui/material'

const MajorTraumaNetwork = () => {
  const { medPlan, setMedPlan } = useContext(MedPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12}>
      <TextField
        label="Major Trauma Network"
        multiline
        minRows={2}
        value={medPlan?.majorTraumaNetwork}
        fullWidth
        onChange={(e) => {
          setMedPlan((prev) => ({
            ...prev,
            majorTraumaNetwork: e.target.value,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        InputLabelProps={{
          shrink: !!medPlan?.majorTraumaNetwork,
        }}
      />
    </Grid>
  )
}

export default React.memo(MajorTraumaNetwork)
